/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicensesDto } from '../../models/licenses-dto';

export interface LicensesGetLicenses$Params {
}

export function licensesGetLicenses(http: HttpClient, rootUrl: string, params?: LicensesGetLicenses$Params, context?: HttpContext): Observable<StrictHttpResponse<LicensesDto>> {
  const rb = new RequestBuilder(rootUrl, licensesGetLicenses.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LicensesDto>;
    })
  );
}

licensesGetLicenses.PATH = '/api/licenses';
